module.exports = __webpack_public_path__ + "static/img/bx3.c1690e1d.png";